// src/components/ProtectedRouteManager.js

import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRouteManager = ({ children }) => {
  const token = localStorage.getItem('tokenManager');
  if (!token) {
    // User not logged in, redirect to login page
    return <Navigate to="/manager/login" replace />;
  }

  // User is logged in, allow access to the route
  return children;
};

export default ProtectedRouteManager;
